import { render, staticRenderFns } from "./LanguageBar.vue?vue&type=template&id=6f908156&scoped=true&"
import script from "./LanguageBar.vue?vue&type=script&lang=js&"
export * from "./LanguageBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f908156",
  null
  
)

export default component.exports